<template>
    <div class="filters" ref="filtersbar">
        <div class="filters__mobile-bar" role="button" v-on:click="toggleFilterBar()">{{ mixologyData.FILTER_BY }}</div>
        <div :class="['filters__bar', (isFilterBarOpen) ? 'open' : '' ]" >
            <p  id="filter-list-label">{{ mixologyData.FILTER_BY}}:</p>
            <ul aria-labelledby="filter-list-label">
                <li v-for="(filter, i) in filtersList" :key="i" :class="[ ( getActiveFilter === filter.name) ? 'active' : '' ]">
                    <button v-on:click="setfilter({active:filter.name, sub:''})">
                        {{ filter.name }} 
                        <custom-icon v-if="filter.sublist" :link="filterArrow"></custom-icon>
                    </button>
                     <ul :class="['filters__sublist', (getActiveFilter === filter.name && isSubFilterBarOpen) ? 'open': '' ]">
                        <li v-for="(item, i) in removeUselessFilters(filter.sublist, InitialList)" :key="i" v-on:click="setfilter({active:filter.name, sub:item})">
                            {{ item }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import mixologyData from "./../../../static/libs/mixology";
import filterArrow from "@/assets/mixology/icons/nav-arrow.svg"
import { mapGetters, mapActions } from "vuex";
import CustomIcon from "@/components/custom-icons/Icon";

export default {
    name: "filters",
    props: {
        filtersList: {
            type: Array[Object]
        }
    },
    components: {
        CustomIcon
    },
    created () {
        // window.onscroll = function() {this.handleScroll}
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    computed: mapGetters(["getActiveFilter", "isFilterBarOpen", "isSubFilterBarOpen", "InitialList"]),
    methods: {
        ...mapActions(["setActiveFilter", "toggleFilterBar", "applyFilter"]),
        setfilter(params) {
            this.setActiveFilter(params)
            this.applyFilter()
        },
        removeUselessFilters(subfilts=[], initial) {
            const relivantFilters = []
            for(let item of initial) {
                for(let subItem of item.filters){
                    if(subfilts.includes(subItem)) relivantFilters.push(subItem)
                }
            }
            //Remove dupicates and alphabetize
            return relivantFilters.reduce((accu, curr) => {
                if (accu.indexOf(curr) === -1) {
                    accu.push(curr)
                }
                return accu
            }, []).sort()
        },
        handleScroll(e){
            const filtersbar = this.$refs.filtersbar
            const sticky = filtersbar.offsetTop;
            (window.pageYOffset >= sticky  - 87 ) ? filtersbar.classList.add("sticky") : filtersbar.classList.remove("sticky");
        }
    },
    data() {
        return {
            mixologyData,
            filterArrow
        };
    }
};
</script>

<style lang="scss">
@import "./../../variables.scss";

.filters {
    position: relative;
    width: 100%;
    background-color: $bubly-blue;
    // top: 325px;
    z-index: 10;

    &__mobile-bar {
        display: flex;
        position: relative;
        align-items: center;
        text-align: left;
        background-color: inherit;
        height: 2.063rem;
        padding: 0 15px;
        cursor: pointer;
        z-index: 101;

        p {
            margin: 0;
        }
    }

    &__bar {
        width: 100%;
        height: 2.063rem;
        margin-top: -2.063rem;
        background-color: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        transition: margin-top .3s ease-out;

        &.open {
            margin-top: 0;
        }

        p {
            display: none;
            margin: 0;
        }
        ul {
            list-style: none;
            margin: 0;
            padding: 0;

            > li {
                display: inline-block;
                margin: 10px 5px;

                > button {
                    background-color: transparent;
                    height: 1.25rem;
                    padding: 0 5px;
                    border: 1px solid #fff;
                    color: #fff;
                    font-size: 0.625rem;
                    border-radius: 1rem;
                    outline: none;
                    cursor: pointer;

                    &:hover {
                        border: 1px solid $bubly-blue-light;
                    }

                    svg{
                        width: 5px;
                        height: 7px;
                        fill: #fff;
                    }
                }

                ul.filters__sublist {
                    display: flex;
                    position: absolute;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    margin-top: 6px;
                    width: 100%;
                    height: 0;
                    max-height: 0;
                    overflow: hidden;
                    background-color: $bubly-blue;
                    justify-content: center;
                    left: 0;
                    color: #fff;
                    box-shadow: inset 0 7px 9px -7px rgba($color: #000, $alpha: .5);
                    z-index: -1;
                    transition: max-height 1s ease-in-out;

                    li {
                        padding: 0 10px;
                        cursor: pointer;
                        font-size: 0.813rem;

                        &:hover {
                            // margin-top: 15px
                        }
                    }

                    &.open {
                        height: auto;
                        max-height: 999px;
                    }
                }

                &.active {
                    > button {
                        background-color: #fff;
                        color: $bubly-blue;

                        svg {
                            fill: $bubly-blue;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 337px) {
        &__bar {
            height: 88px;
            overflow: hidden;
        }
        &__bar.open{
            height: 3.5em;
            ul li {
                margin: 5px 3px;
                > button {
                    font-size: 0.575rem;
                }
            }
        }
    };


    @media (min-width: 768px) {
        // top: -3.125rem;
        &.sticky {
            margin-top: 88px;
            .filters__bar{
                position: fixed;
                top: 0px;
                width: 100%;
            }
        }

        &__mobile-bar {
            display: none;
        }
        &__bar {
            // position: fixed;
            height: 3.125rem;
            margin-top: 0;
            margin-top: 5.5rem;
            transition: unset;



            p {
                display: inline;  
                margin-right: 3em;  
            }

            ul li {
                button {
                    height: 1.875rem;
                    padding: 0 20px;
                    border-radius: 1rem;
                    font-size: 0.813rem;
                }
                ul.filters__sublist {
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin-top: 10px;
                }
            }
            



        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/mixology/Filters.vue